import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'jep-dash-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SideBarComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
